import { Box, Button, Container, Stack, Typography } from "@mui/material";

import { app_logo_full } from "@/constants";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { tokens } from "@/tokens";

const StyledButton = styled(Button)({
    color: tokens.bg.surface,
    fontSize: tokens.fontSize.lg,
    fontWeight: tokens.fontWeight.semibold,
    padding: "10px 24px",
    borderRadius: tokens.radius.sm,
});
const Careers = () => {
    const navigate = useNavigate();
    return (
        <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            <Box sx={{ width: "100%", zIndex: 9, backgroundColor: '#000' }}>
                <Container>
                    <Stack py="1.5rem" onClick={() => navigate("/")} sx={{ cursor: "pointer" }} direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                        <Box component="img" src={app_logo_full} width={98} />
                        <StyledButton
                            variant="contained"
                            sx={{
                                background: tokens.brand.accent,
                                color: tokens.text.primary,
                                fontSize: { xs: 9, sm: 14 },
                                width: { xs: 70, sm: "auto" },
                            }}
                            onClick={() => navigate("/login")}
                        >
                            Login
                        </StyledButton>
                    </Stack>
                </Container>
            </Box>

            {/* Main Content */}
            <Box
                sx={{
                    backgroundColor: '#000',
                    display: "flex",
                    flex: 1, // Fixes height issue
                    flexDirection: "column",
                    justifyContent: "space-between"
                }}
            >
                <Box
                    sx={{
                        width: { xs: "100%", lg: "60%" },
                        height: "80%",
                        position: "absolute",
                        background: "rgba(51, 218, 224, 0.15)",
                        top: "15%",
                        borderRadius: "50%",
                        filter: { xs: "blur(90px)", lg: "blur(115px)" },
                        zIndex: 1,
                        display: { xs: "none", md: "block" },
                    }}
                />

                <Box display={"flex"} justifyContent={"center"} alignItems={"center"} flex={1}>
                    <Typography color={tokens.bg.surface} variant="h2" fontWeight={tokens.fontWeight.heavy} textAlign={"center"} py={10}>
                        No Careers Available
                    </Typography>
                </Box>

                {/* Footer */}
                <Box
                    sx={{
                        color: tokens.bg.surface,
                        borderTop: "1px solid #FFFFFF1A",
                        p: 3,
                        px: { xs: 4, sm: 8 }
                    }}
                >
                    <Typography
                        // color={"#FFFFFF"}
                        fontSize={{ xs: tokens.fontSize["2xs"], sm: tokens.fontSize.xl }}
                        fontWeight={tokens.fontWeight.normal}
                        textAlign={"left"}
                    >
                        © 2025 Riffs Inc. All Rights Reserved.
                    </Typography>
                </Box>
            </Box>
        </Box>

    );
};

export default Careers;
